/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import Vue from 'vue'
import 'regenerator-runtime/runtime'
import VueObserveVisibility from 'vue-observe-visibility'
import 'vue-select/dist/vue-select.css'
import sampleData from './sampleData'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
window.Vue = require('vue').default
import store from './store'

Vue.config.devtools = true

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyAP24WOfBIoDO3NEMabj1HgBzHNZJOnXxI',
    // key: 'AIzaSyCeL0R3EtH5zmK4PQqMGjmc8Bmz6nOlVfM',
    key: 'AIzaSyDXSStyxoc05g6_ZJLIbfXBdW1keyzzHBc',
    libraries: 'places',
  },
})
Vue.component('GmapCluster', GmapCluster)

Vue.use(VueObserveVisibility)

Vue.component('app-header', () => import('./components/Header'))
Vue.component('app-slideshow-services', () => import('./components/SliderServices'))
Vue.component('app-slideshow-testimonials', () => import('./components/SliderTestimonials'))
Vue.component('app-our-people', () => import('./components/OurPeople'))
Vue.component('app-gallery', () => import('./components/GalleryArea'))
Vue.component('app-accordion', () => import('./components/AppAccordion'))
Vue.component('app-sidebar', () => import('./components/Sidebar'))
Vue.component('app-news', () => import('./components/NewsList'))
Vue.component('app-what-we-do', () => import('./components/WhatWeDoList'))
Vue.component('app-change-password', () => import('./components/ChangePassword'))

Vue.component('app-home-hero', () => import('./components/HomeHero'))
Vue.component('mobile-home-hero', () => import('./components/MobileHomeHero'))
Vue.component('project-detail-hero', () => import('./components/ProjectDetailHero'))
Vue.component('slider-hero', () => import('./components/SliderHero'))
Vue.component('app-home-values', () => import('./components/HomeValues'))

Vue.component('contact-map', () => import('./components/ContactMap'))
Vue.component('app-map', () => import('./components/Map'))
Vue.component('app-projects-list', () => import('./components/ProjectsList'))
Vue.component('select-with-clear', () => import('./components/SelectWithClear'))
Vue.component('search-box', () => import('./components/SearchBox'))
Vue.component('career-slider', () => import('./components/CareerSlider'))
Vue.component('aotearoa-card', () => import('./components/AotearoaCard'))
Vue.component('related-projects', () => import('./components/RelatedProjects'))
Vue.component('related-articles', () => import('./components/RelatedArticles'))

new Vue({
  store,
  data: () => ({
    isLoaded: false,
    isHome: false,
    isSidebarWhite: false,
    isScrollFinished: false,
    isScrollFinishedMobile: false,
    isIntroVisible: false,
    isConclusionVisible: false,
    isValuesVisible: false,
    isFooterVisible: false,
    faq: null,
    tab: 'en',
    samplePeople: sampleData.people,
    sampleFilters: sampleData.filterOptions,
    positionFilters: sampleData.positionFilters,
    expertiseFilters: sampleData.expertiseFilters,
    sampleProjects: sampleData.projects,
    footerIntersection: {
      root: document,
      rootMargin: '0px 0px 0px 0px',
      threshold: 0,
    },
    historyIntersection: {
      root: document,
      rootMargin: '-250px 0px -250px 0px',
      threshold: 1,
    },
    historyId: 1,
    manualHistory: false,
    scrollTop: 0,
    unwatch: null,
  }),

  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.sidebar,
      (newVal) => {
        this.isSidebarWhite = newVal
      }
    )
  },

  mounted() {
    const pathname = window.location.pathname
    if (
      pathname === '/' ||
      pathname === '/home' ||
      pathname === '/statics/home'
    ) {
      // console.log(window.location)
      this.isHome = true
    } else if (
      pathname.includes('/projects/') ||
      // pathname.includes('/projects/') ||
      pathname.includes('/careers') ||
      pathname == '/what-we-do'
    ) {
      this.isSidebarWhite = this.$store.state.isSidebarWhite
    }

    document.onreadystatechange = () => {
      if (document.readyState == 'complete') {
        this.isLoaded = true
      }
    }

    const nextSection = document.getElementById('tab-section')

    window.addEventListener(
      'scroll',
      () => {
        this.scrollTop =
          document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        //if (this.isScrollFinished) {
        //this.isScrollFinished = this.scrollTop > nextSection.offsetTop + 100
        // this.isScrollFinished = this.scrollTop
        //} else {
        //this.isScrollFinished = this.scrollTop > nextSection.offsetTop + 20
        //this.isScrollFinished = this.scrollTop
        // }
      },
      true
    )
  },

  beforeDestroy() {
    this.unwatch()
  },

  methods: {
    toggleTab(tab) {
      this.tab = tab
    },

    toggleFAQ(index) {
      if (index === this.faq) {
        this.faq = null
      } else {
        this.faq = index
      }
    },

    introVisibilityChanged(isVisible, entry) {
      this.isIntroVisible = isVisible
    },

    conclusionVisibilityChanged(isVisible, entry) {
      this.isConclusionVisible = isVisible
    },

    historyItemVisibility(isVisible, entry, id) {
      if (isVisible) this.historyId = id
      else return
    },

    showHistory(id) {
      this.historyId = id
      this.manualHistory = true
    },

    enableAutoHistory(isVisible, entry) {
      if (isVisible) this.manualHistory = false
      else return
    },

    footerVisibility(isVisible) {
      this.isFooterVisible = isVisible
      console.log(this.isFooterVisible)
    },
  },
  watch: {
    $route (to,from) {
      this.$store.state.isSidebarWhite = false;
    },
  }
}).$mount('#app')
